export default function loadBranchData(branch, ctx) {
  const tasks = (branch || []).map(({ route, match }) => {
    if (!route) return null;

    if (typeof route.loadData === 'function') {
      return route.loadData({ ...ctx, params: (match && match.params) || {} });
    }

    const Component = route.component;
    if (Component && typeof Component.loadData === 'function') {
      return Component.loadData({ ...ctx, params: (match && match.params) || {} });
    }

    return null;
  }).filter(Boolean);

  return Promise.all(tasks);
}
